import { clsx } from "clsx";
import React, { PropsWithChildren } from "react";
import IcoSpinner from "src/assets/IcoSpinner";

interface ButtonProps extends PropsWithChildren {
  type?: "button" | "submit" | "reset";
  variant?: "contained" | "outlined";
  size?: "sm" | "md" | "full";
  buttonStyle?: string;
  onClick?: (evt: React.MouseEvent<HTMLButtonElement>) => void;
  isLoading?: boolean;
  disable?: boolean;
  color?: "primary" | "secondary";
}

export default function GradientButton(props: ButtonProps) {
  const {
    children,
    onClick,
    buttonStyle,
    type = "button",
    variant = "outlined",
    size = "md",
    isLoading = false,
    disable = false,
    color = "primary",
  } = props;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) onClick(e);
  };

  return (
    <button
      className={clsx(
        "btn-gradient flex items-center justify-center space-x-2",
        {
          "btn-gradient-contained": variant === "contained" && color === "primary",
          "btn-gradient-outlined": variant === "outlined" && color === "primary",
          "btn-orange border-none": variant === "contained" && color === "secondary",
          "btn-gradient-sm": size === "sm",
          "h-full w-full": size === "full",
        },
        buttonStyle,
      )}
      type={type}
      onClick={handleClick}
      disabled={disable || isLoading}
    >
      <span className={clsx("relative")}>
        <span
          className={clsx({
            "opacity-0": isLoading,
          })}
        >
          {children}
        </span>
        {isLoading && (
          <span className="absolute top-0 left-0 flex h-full w-full items-center justify-center">
            <IcoSpinner
              className={clsx("!mr-0", {
                "!h-5 !w-5": size === "md",
              })}
            />
          </span>
        )}
      </span>
    </button>
  );
}
